/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsdlctooltip2Inputs */

const id_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar pencapaian ini untuk salah satu DLC.`)
};

const ms_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai pencapaian ini adalah untuk salah satu DLC.`)
};

const da_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne liste af achievements er for en af DLC'erne.`)
};

const de_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Liste von Errungenschaften ist für einen der DLCs.`)
};

const en_us2_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This list of achievements are for one of the DLCs.`)
};

const es_es2_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para uno de los DLCs.`)
};

const es_mx2_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para uno de los DLC.`)
};

const fil_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang listahang ito ng achievement ay para sa isa sa mga DLC.`)
};

const fr_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette liste de succès concerne l'un des DLC.`)
};

const it_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo elenco di risultati è per uno dei DLC.`)
};

const hu_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a teljesítménylista az egyik DLC-hez tartozik.`)
};

const nl_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze lijst met prestaties is voor een van de DLC's.`)
};

const no_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne listen over prestasjoner er for en av DLC-ene.`)
};

const pl_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta lista osiągnięć dotyczy jednego z DLC.`)
};

const pt_br2_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para uma das DLCs.`)
};

const pt_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para um dos DLCs.`)
};

const ro_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această listă de realizări este pentru unul dintre DLC-uri.`)
};

const fi_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä saavutuslista koskee yhtä DLC:stä.`)
};

const sv_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna lista med prestationer är för ett av DLC-paketen.`)
};

const vi_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách thành tích này dành cho một trong các DLC.`)
};

const tr_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu başarım listesi DLC'lerden biri içindir.`)
};

const cs_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento seznam úspěchů je pro jedno z DLC.`)
};

const bg_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този списък с постижения е за едно от DLC-тата.`)
};

const ru_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот список достижений для одного из DLC.`)
};

const uk_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей список досягнень для одного з DLC.`)
};

const ar_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة الإنجازات هذه لأحد DLC.`)
};

const hi_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियों की यह सूची एक DLC के लिए है।`)
};

const th_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการความสำเร็จนี้สำหรับหนึ่งใน DLC`)
};

const ja_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この実績リストはDLCの1つ用です。`)
};

const zh_cn2_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此列表显示的是其中一个DLC的成就。`)
};

const zh_hant1_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此清單顯示的是其中一個DLC的成就。`)
};

const ko_sandboxes_achievementsdlctooltip2 = /** @type {(inputs: Sandboxes_Achievementsdlctooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도전 과제 목록은 DLC 중 하나용입니다.`)
};

/**
* | output |
* | --- |
* | "This list of achievements are for one of the DLCs." |
*
* @param {Sandboxes_Achievementsdlctooltip2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsdlctooltip2 = /** @type {((inputs?: Sandboxes_Achievementsdlctooltip2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsdlctooltip2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "da") return da_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "de") return de_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "it") return it_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "no") return no_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "th") return th_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsdlctooltip2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsdlctooltip2(inputs)
	return ko_sandboxes_achievementsdlctooltip2(inputs)
});
export { sandboxes_achievementsdlctooltip2 as "sandboxes.achievementsDlcTooltip" }